import { onMounted, onUnmounted, ref } from 'vue';
import useLocalStreamingDevicesStore from '@/Stores/useLocalStreamingDevicesStore';

function useUpdateMediaDevicesList() {
  const multiDeviceStore = useLocalStreamingDevicesStore();
  const newDevicesList = ref(null);
  const updateQueue = [];
  let processing = false;

  const processQueue = async () => {
    if (processing || updateQueue.length === 0) return;
    const nextUpdate = updateQueue.shift();

    try {
      processing = true;
      await nextUpdate();
    } catch (error) {
      console.error('Error occurred while updating device list:', error);
    } finally {
      processing = false;

      await processQueue();
    }
  };

  const updateDeviceList = async (newList) => {
    const updateFunction = async () => {
      multiDeviceStore.setLocalMediaDevices(newList);
      newDevicesList.value = newList;

      await multiDeviceStore.handleMediaDevicesChange();
    };

    updateQueue.push(updateFunction);
    await processQueue();
  };

  onMounted(() => {
    JitsiMeetJS.mediaDevices.addEventListener(
      JitsiMeetJS.events.mediaDevices.DEVICE_LIST_CHANGED,
      updateDeviceList,
    );
  });

  onUnmounted(() => {
    JitsiMeetJS.mediaDevices.removeEventListener(
      JitsiMeetJS.events.mediaDevices.DEVICE_LIST_CHANGED,
      updateDeviceList,
    );
  });

  return newDevicesList;
}

export default useUpdateMediaDevicesList;
